<template>
  <div class="m-5">
    <b-form-group id="input-group-1" label="名前:">
      <b-form-input
        type="text"
        v-model="nickname"
        placeholder="Enter your name"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="好きなジャンル:">
      <b-form-checkbox-group
        v-model="genres"
        :options="genreOptions"
      ></b-form-checkbox-group>
    </b-form-group>

    <b-form-group label="ひとこと:">
      <b-form-textarea
        v-model="comment"
        placeholder="私は小説が好きです。"
        rows="3"
      ></b-form-textarea>
    </b-form-group>

    <b-button v-b-modal.modal-1 @click="profileUpdate" class="m-3"
      >更新</b-button
    >
    <b-button v-b-modal.modal-1 @click="goToMyPage" class="m-3"
      >マイページに戻る</b-button
    >
    <b-modal id="modal-1" ok-only>
      <p class="my-4">設定を更新しました</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nickname: this.$store.getters.user.name,
      genres: this.$store.getters.user.genres,
      comment: this.$store.getters.user.comment,
      genreOptions: [
        { text: "文学・評論", value: "文学・評論" },
        { text: "人文・思想", value: "人文・思想" },
        { text: "社会・政治", value: "社会・政治" },
        { text: "ノンフィクション", value: "ノンフィクション" },
        { text: "歴史・地理", value: "歴史・地理" },
        { text: "ビジネス・経済", value: "ビジネス・経済" },
        { text: "投資・金融・会社経営", value: "投資・金融・会社経営" },
        { text: "科学・テクノロジー", value: "科学・テクノロジー" },
        { text: "医学・薬学", value: "医学・薬学" },
        { text: "コンピュータ・IT", value: "コンピュータ・IT" },
        { text: "アート・建築・デザイン", value: "アート・建築・デザイン" },
        { text: "趣味・実用", value: "趣味・実用" },
        { text: "スポーツ・アウトドア", value: "スポーツ・アウトドア" },
        { text: "資格・検定・就職", value: "資格・検定・就職" },
        { text: "暮らし・健康・子育て", value: "暮らし・健康・子育て" },
        { text: "旅行ガイド・マップ", value: "旅行ガイド・マップ" },
        { text: "語学・辞事典・年鑑", value: "語学・辞事典・年鑑" },
        { text: "教育・学参・受験", value: "教育・学参・受験" },
        { text: "絵本・児童書", value: "絵本・児童書" },
        { text: "マンガ", value: "マンガ" },
        { text: "ライトノベル", value: "ライトノベル" },
        { text: "BL", value: "BL" },
        { text: "タレント写真集", value: "タレント写真集" },
        { text: "エンターテイメント", value: "エンターテイメント" },
        { text: "雑誌", value: "雑誌" },
        { text: "楽譜・スコア・音楽書", value: "楽譜・スコア・音楽書" },
        { text: "アダルト", value: "アダルト" }
      ]
    };
  },
  methods: {
    profileUpdate() {
      this.$store.dispatch("updateUserData", {
        name: this.nickname,
        genres: this.genres,
        comment: this.comment
      });
    },
    goToMyPage() {
      this.$router.push("/user/" + this.$store.getters.user.uid);
    }
  }
};
</script>
